import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function SafetySection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section id="safety" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-6 rounded-full bg-accent-100">
          <i className="ri-shield-check-line text-2xl md:text-3xl text-accent-600"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-5">
          {t('safety.title')}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto">
          {t('safety.content')}
        </p>
        <button
          onClick={() => {
            navigate('/artykul/kakobuy-bezpieczne-zakupy');
            window.scrollTo(0, 0);
          }}
          className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t('safety.cta')}
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </section>
  );
}